import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  watch,
  computed,
  withDefaults,
} from 'vue';
import TuiInput from '../common/base/Input';
import TuiCheckbox from '../common/base/Checkbox';
import TuiButton from '../common/base/Button.vue';
import TuiAvatar from '../common/Avatar.vue';
import SearchIcon from '../common/icons/SearchIcon.vue';
import CloseIcon from '../common/icons/CloseIcon.vue';
import PanelContainer from './PanelContainer.vue';

import { useI18n } from '../../locales';

interface Props {
  visible: boolean;
  contacts: any[];
  selectedList?: any[];
  isMobile?: boolean;
  disabledList?: any[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Contacts',
  props: {
    visible: { type: Boolean },
    contacts: null,
    selectedList: null,
    isMobile: { type: Boolean, default: false },
    disabledList: null
  },
  emits: ['input', 'confirm'],
  setup(__props: any, { emit }) {

const props = __props as { visible: boolean, contacts: any[], selectedList?: any[], isMobile: boolean, disabledList?: any[] };

const { t } = useI18n();



const isDialogVisible = ref(false);
const searchValue = ref('');
const updateContacts = () => {
  contacts.value = props.contacts.map(user => {
    const index = props.selectedList?.findIndex(
      selectedUser => selectedUser.userId === user.userID
    );
    const disableUserIndex = props.disabledList?.findIndex(
      disableUser => disableUser.userId === user.userID
    );
    return {
      selected: index !== undefined && index !== -1,
      disabled: disableUserIndex !== undefined && disableUserIndex !== -1,
      userInfo: user,
    };
  });
};
const updateVisible = (val: boolean) => {
  updateContacts();
  emit('input', val);
};

const contacts = ref(
  props.contacts.map(user => {
    const index = props.selectedList?.findIndex(
      selectedUser => selectedUser.userId === user.userID
    );
    const disableUserIndex = props.disabledList?.findIndex(
      disabledUser => disabledUser.userId === user.userID
    );
    return {
      selected: !!index && index !== -1,
      disabled: !!disableUserIndex && disableUserIndex !== -1,
      userInfo: user,
    };
  })
);
const selectedContacts = computed(() =>
  contacts.value.filter(user => user.selected)
);
const searchResult = ref<any>([]);
const showList = computed(() =>
  searchValue.value ? searchResult.value : contacts.value
);
const searchContact = (v: any) => {
  if (!v) return [];
  searchResult.value = contacts.value.filter(
    item =>
      item.userInfo.profile.nick.includes(v) || item.userInfo.userID.includes(v)
  );
};

const removeSelectUser = (user: { selected: boolean; userInfo: any }) => {
  const index = contacts.value.findIndex(
    item => user.userInfo.userID === item.userInfo.userID
  );
  contacts.value[index].selected = false;
};
const confirm = () => {
  emit(
    'confirm',
    selectedContacts.value.map(item => {
      const { userID, profile } = item.userInfo;
      return {
        userId: userID,
        userName: profile.nick,
        avatarUrl: profile.avatar,
      };
    })
  );
  updateVisible(false);
};

const cancel = () => {
  updateVisible(false);
};

watch(
  () => props.visible,
  val => {
    isDialogVisible.value = val;
  },
  {
    immediate: true,
  }
);

watch(
  isDialogVisible,
  val => {
    searchValue.value = '';
    updateVisible(val);
  },
  { immediate: true }
);

return { __sfc: true,t, props, emit, isDialogVisible, searchValue, updateContacts, updateVisible, contacts, selectedContacts, searchResult, showList, searchContact, removeSelectUser, confirm, cancel, TuiInput, TuiCheckbox, TuiButton, TuiAvatar, SearchIcon, CloseIcon, PanelContainer }
}

})